import { moveToFulfilled, remove } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  FeedLoadFulfilledAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../domains/feedLoad/actions.types';
import type {
  NestedThreadDeepLinkSecondLevelLoadFulfilledAction,
  NestedThreadDeepLinkTopLevelLoadFulfilledAction,
  NestedThreadLoadFulfilledAction,
} from '../../domains/nestedThread/types';
import type { NestedThreadListLoadFulfilledAction } from '../../domains/nestedThreadList/actions.types';
import type { SearchLoadFulfilledAction, SearchLoadMoreFulfilledAction } from '../../domains/searches/actions.types';
import type { TeamsMeetingAction } from '../teamsMeetings/reducer';

import type { TeamsMeetingReferences } from './types';

export type TeamsMeetingReferencesAction =
  | TeamsMeetingAction
  | NestedThreadLoadFulfilledAction
  | NestedThreadDeepLinkTopLevelLoadFulfilledAction
  | NestedThreadDeepLinkSecondLevelLoadFulfilledAction
  | NestedThreadListLoadFulfilledAction
  | FeedLoadFulfilledAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | SearchLoadFulfilledAction
  | SearchLoadMoreFulfilledAction;

const initialState: TeamsMeetingReferences = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<TeamsMeetingReferences, TeamsMeetingReferencesAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NESTED_THREAD.LOAD_FULFILLED':
    case 'NESTED_THREAD.LOAD_DEEP_LINK_TOP_LEVEL_FULFILLED':
    case 'NESTED_THREAD.LOAD_DEEP_LINK_SECOND_LEVEL_FULFILLED':
    case 'NESTED_THREAD_LIST.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.teamsMeetingReferences);
    case 'CREATE_TEAMS_MEETING.FULFILLED':
    case 'SCHEDULE_AND_CREATE_TEAMS_MEETING.FULFILLED':
    case 'TEAMS_MEETINGS_BY_ORGANIZER.LOAD_FULFILLED':
    case 'EDIT_TEAMS_MEETING.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.teamsMeetingReferences);
    case 'DELETE_TEAMS_MEETING.FULFILLED':
      return remove(state, [action.payload.id]);
    case 'TEAMS_MEETING.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.teamsMeetingReferences);
    case 'FEED.LOAD_FULFILLED':
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.teamsMeetingReferences);
    case 'SEARCH.LOAD_FULFILLED':
    case 'SEARCH.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.teamsMeetingReferences);
    default:
      return state;
  }
};

export default reducer;
